<button
  class="back-to-top"
  [class.is-visible]="showScrollTop"
  type="button"
  aria-label="Back to top"
  (click)="scrollToTop()"
>
  <img
    class="scroll-bar-icon"
    src="assets/scroll-bar/scroll-bar.png"
    alt=""
    aria-hidden="true"
  />
</button>
